<template>
  <v-dialog
    v-model="formState"
    :max-width="isMobile?undefined:formWidth"
    :fullscreen="isMobile"
    scrollable
    :transition="isMobile?'dialog-bottom-transition':'fade-transition'"
  >
      <!-- Dynamically load component -->
      <component :is="component" v-bind="props"/>
  </v-dialog>
</template>

<script>
import { useFloatFormStore } from "@/store/floatForm";
import { computed, defineAsyncComponent } from "vue";
import { useDisplay } from 'vuetify';

export default {
  name: "FloatForm",
  setup() {

    const props = computed(() => floatFormStore.props || {});

    const floatFormStore = useFloatFormStore();

    const { mobile } = useDisplay();
    const isMobile = computed(() => mobile.value);

    const formTitle = computed(() => floatFormStore.formTitle);
    const formWidth = computed(() => floatFormStore.formWidth);

    const formState = computed({
      get: () => floatFormStore.isOpen,
      set: (val) => {
        if (!val) floatFormStore.closeForm(); // o lo que sea tu método para cerrar
      }
    });

    // Dynamically import the component based on the store value
    const context = require.context('../form', false, /\.vue$/);

    const component = computed(() => {
      const comp = floatFormStore.component;

      // Si ya es un componente Vue (objeto), lo devolvemos directo
      if (typeof comp === 'object' || typeof comp === 'function') {
        return comp;
      }

      // Si es string, intentamos resolver dinámicamente
      const fileName = `./${comp}.vue`;
      if (context.keys().includes(fileName)) {
        return context(fileName).default;
      }

      return context('./DefaultComponent.vue').default;
    });

    
    return {
      formState,
      formTitle,
      formWidth,
      component,
      isMobile,
      props
    };
  },
};
</script>

<style scoped>
.bg-sidebar {
  border: 0px;
}
</style>
